import React from "react";
import { Button } from "antd";

const PrimaryButton = props => <Button type="primary" {...props} />;

export default PrimaryButton;
